function initAssessment() {
  const toolPanel = document.querySelector("#tool-panel");
  if (!toolPanel) return;
  if (toolPanel.dataset.assessmentBound) return;
  toolPanel.dataset.assessmentBound = "true";

  const ideaStep    = document.querySelector("#idea-step");
  const loaderStep  = document.querySelector("#loader-step");
  const emailStep   = document.querySelector("#email-step");
  const ideaTextarea = document.querySelector("#idea-textarea");
  const validateBtn = document.querySelector("#validate-btn");
  const emailInput  = document.querySelector("#email-input");
  const emailBtn    = document.querySelector("#email-btn");
  const ideaError   = document.querySelector("#idea-error");
  const emailError  = document.querySelector("#email-error");
  const loaderPhrase = document.querySelector("#loader-phrase");
  const ideaCounter = document.querySelector("#idea-counter");
  const ideaHint    = document.querySelector("#idea-hint");

  const MIN_CHARS = 350;
  const MAX_CHARS = 1000;

  let currentToken = null;

  const POLL_INTERVAL_MS = 3000;
  const MAX_POLL_ATTEMPTS = 80; // ~4 minutes

  const pollAssessment = async (token) => {
    for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
      await new Promise(r => setTimeout(r, POLL_INTERVAL_MS));
      const res = await fetch(`/mvp_assessments/${token}.json`, {
        headers: { "X-CSRF-Token": csrf() }
      });
      if (!res.ok) throw new Error("Errore nel controllo dell'analisi.");
      const result = await res.json().catch(() => ({}));
      if (result.status === "completed") return result;
      if (result.status === "failed") throw new Error(result.error || "Errore durante l'analisi.");
      // queued or processing → keep polling
    }
    throw new Error("Timeout: l'analisi ha impiegato troppo tempo. Riprova.");
  };

  const PHRASES = [
    "Mettiamo in ordine l'idea...",
    "Analizziamo la coerenza del mercato...",
    "Identifichiamo i potenziali punti critici...",
    "Esaminiamo i punti di forza...",
    "Quasi pronto: stiamo definendo la strategia..."
  ];

  let phraseInterval = null;

  const startPhraseRotation = () => {
    let idx = 0;
    if (loaderPhrase) loaderPhrase.textContent = PHRASES[idx];
    phraseInterval = setInterval(() => {
      idx = (idx + 1) % PHRASES.length;
      if (loaderPhrase) loaderPhrase.textContent = PHRASES[idx];
    }, 2800);
  };

  const stopPhraseRotation = () => {
    clearInterval(phraseInterval);
    phraseInterval = null;
  };

  const showStep = (step) => {
    [ideaStep, loaderStep, emailStep].forEach(s => { if (s) s.hidden = true; });
    if (step) step.hidden = false;
  };

  const updateCounter = () => {
    const len = ideaTextarea ? ideaTextarea.value.length : 0;
    if (ideaCounter) ideaCounter.textContent = `${len} / ${MAX_CHARS}`;

    if (len === 0) {
      ideaTextarea?.classList.remove("ux-input--error", "ux-input--ok");
      if (ideaHint)    { ideaHint.textContent = `Min. ${MIN_CHARS} caratteri`; ideaHint.className = "mvp-char-hint"; }
      if (ideaCounter) ideaCounter.className = "mvp-char-count";
    } else if (len < MIN_CHARS) {
      ideaTextarea?.classList.add("ux-input--error");
      ideaTextarea?.classList.remove("ux-input--ok");
      if (ideaHint)    { ideaHint.textContent = `Ancora ${MIN_CHARS - len} caratteri`; ideaHint.className = "mvp-char-hint mvp-char-hint--warn"; }
      if (ideaCounter) ideaCounter.className = "mvp-char-count mvp-char-count--warn";
    } else if (len >= MAX_CHARS) {
      ideaTextarea?.classList.add("ux-input--ok");
      ideaTextarea?.classList.remove("ux-input--error");
      if (ideaHint)    { ideaHint.textContent = "Limite raggiunto"; ideaHint.className = "mvp-char-hint mvp-char-hint--warn"; }
      if (ideaCounter) ideaCounter.className = "mvp-char-count mvp-char-count--max";
    } else {
      ideaTextarea?.classList.add("ux-input--ok");
      ideaTextarea?.classList.remove("ux-input--error");
      if (ideaHint)    { ideaHint.textContent = "✓ Lunghezza ottimale"; ideaHint.className = "mvp-char-hint mvp-char-hint--ok"; }
      if (ideaCounter) ideaCounter.className = "mvp-char-count mvp-char-count--ok";
    }
  };

  if (ideaTextarea) ideaTextarea.addEventListener("input", updateCounter);
  updateCounter();

  const csrf = () =>
    document.querySelector("meta[name='csrf-token']")?.content || "";

  // ── Step 1: Submit idea ───────────────────────────────────
  const handleIdeaSubmit = async () => {
    const idea = ideaTextarea?.value?.trim() || "";

    if (idea.length < MIN_CHARS) {
      if (ideaError) {
        ideaError.hidden = false;
        ideaError.textContent = `Descrivi la tua idea in almeno ${MIN_CHARS} caratteri.`;
      }
      ideaTextarea?.focus();
      return;
    }

    if (idea.length > MAX_CHARS) {
      if (ideaError) {
        ideaError.hidden = false;
        ideaError.textContent = `La descrizione non può superare ${MAX_CHARS} caratteri.`;
      }
      ideaTextarea?.focus();
      return;
    }

    if (ideaError) ideaError.hidden = true;
    if (validateBtn) validateBtn.disabled = true;

    showStep(loaderStep);
    startPhraseRotation();

    try {
      const res = await fetch("/mvp_assessments/stream", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf()
        },
        body: JSON.stringify({ lead: { idea } })
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const message =
          (data.errors || []).join(" ") ||
          data.error ||
          "Errore durante l'analisi. Riprova tra poco.";

        stopPhraseRotation();
        showStep(ideaStep);
        if (ideaError) { ideaError.hidden = false; ideaError.textContent = message; }
        if (validateBtn) validateBtn.disabled = false;
        return;
      }

      currentToken = data.token;

      try {
        await pollAssessment(currentToken);
      } catch (pollErr) {
        stopPhraseRotation();
        showStep(ideaStep);
        if (ideaError) { ideaError.hidden = false; ideaError.textContent = pollErr.message || "Errore durante l'analisi. Riprova tra poco."; }
        if (validateBtn) validateBtn.disabled = false;
        return;
      }

      stopPhraseRotation();
      showStep(emailStep);
      emailInput?.focus();
    } catch {
      stopPhraseRotation();
      showStep(ideaStep);
      if (ideaError) {
        ideaError.hidden = false;
        ideaError.textContent = "Connessione instabile. Verifica la rete e riprova.";
      }
      if (validateBtn) validateBtn.disabled = false;
    }
  };

  // ── Step 2: Submit email ──────────────────────────────────
  const handleEmailSubmit = async () => {
    const email = emailInput?.value?.trim() || "";

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (emailError) {
        emailError.hidden = false;
        emailError.textContent = "Inserisci un indirizzo email valido.";
      }
      emailInput?.focus();
      return;
    }

    if (emailError) emailError.hidden = true;
    if (emailBtn) emailBtn.disabled = true;

    try {
      const res = await fetch(`/mvp_assessments/${currentToken}/claim`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf()
        },
        body: JSON.stringify({ lead: { email } })
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        if (emailError) {
          emailError.hidden = false;
          emailError.textContent = data.error || "Errore. Riprova tra poco.";
        }
        if (emailBtn) emailBtn.disabled = false;
        return;
      }

      window.location.href = data.redirect_url;
    } catch {
      if (emailError) {
        emailError.hidden = false;
        emailError.textContent = "Connessione instabile. Verifica la rete e riprova.";
      }
      if (emailBtn) emailBtn.disabled = false;
    }
  };

  if (validateBtn) validateBtn.addEventListener("click", handleIdeaSubmit);
  if (emailBtn) emailBtn.addEventListener("click", handleEmailSubmit);

  // Allow Enter key in email input to submit
  if (emailInput) {
    emailInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") { e.preventDefault(); handleEmailSubmit(); }
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAssessment);
} else {
  initAssessment();
}
document.addEventListener("turbo:load", initAssessment);

